import moment from 'moment';
import { t } from 'i18next';

// --- Recommendation facet label mapping
export const facetLabelMapping = {
  recommendation_category: {
    label: 'GRAAS_TYPE_GRAAS',
    value: 'recommendation_category',
    advertisement: t('GRAAS_ADVERTISEMENT_GRAAS'),
    inventory: t('GRAAS_INVENTORY_GRAAS'),
    storefront: t('GRAAS_STOREFRONT_GRAAS'),
    marketing: t('GRAAS_MARKETING_GRAAS'),
    ads: t('GRAAS_ADS_GRAAS')
  },
  action_priority: {
    label: 'GRAAS_ALL_IMPACTS_GRAAS',
    value: 'action_priority',
    critical: t('GRAAS_HIGH_IMPACT_GRAAS'),
    major: t('GRAAS_MEDIUM_IMPACT_GRAAS'),
    minor: t('GRAAS_LOW_IMPACT_GRAAS'),
    moderate: t('GRAAS_MODERATE_GRAAS'),
    initialState: [
      {
        _id: 'High Impact',
        value: 'critical',
        doc_count: 0
      },
      {
        _id: 'Medium Impact',
        value: 'major',
        doc_count: 0
      },
      {
        _id: 'Low Impact',
        value: 'minor',
        doc_count: 0
      }
    ]
  },
  metrics: {
    label: 'GRAAS_ALL_METRIC_GRAAS',
    value: 'metrics',
    orders: t('GRAAS_ORDERS_GRAAS'),
    'number of vouchers': t('GRAAS_NO_OF_VOUCHERS_GRAAS'),
    revenue: t('GRAAS_REVENUE_GRAAS'),
    'repeat buyer percent': t('GRAAS_REPEAT_BUYER_PERCENT_GRAAS'),
    'repeat buyer percentage': t('GRAAS_REPEAT_BUYER_PERCENT_GRAAS'),
    'days of cover': t('GRAAS_DAYS_OF_COVER_GRAAS'),
    inventory: t('GRAAS_INVENTORY_GRAAS'),
    'fb ads - ad spend': t('GRAAS_FB_ADS_AD_SPEND_GRAAS'),
    'fb ads - clicks': t('GRAAS_FB_ADS_CLICKS_GRAAS'),
    'fb ads - avg cpc': t('GRAAS_FB_ADS_AVG_CPC_GRAAS'),
    'delhivery - delivery time (days)': t('GRAAS_DELHIVERY_DELIVERY_TIME_DAYS_GRAAS'),
    'tracker - checkout page visits': t('GRAAS_TRACKER_CHECKOUT_PAGE_VISITS_GRAAS'),
    'fb ads - roas': t('GRAAS_FB_ADS_ROAS_GRAAS'),
    'google ads - clicks': t('GRAAS_GOOGLE_ADS_CLICKS_GRAAS'),
    'fb Campaigns - roas': t('GRAAS_FB_CAMPAIGNS_ROAS_GRAAS'),
    'fb ads - ctr': t('GRAAS_FB_ADS_CTR_GRAAS'),
    'cost per acquisition': t('GRAAS_COST_PER_ACQUISITION_GRAAS'),
    'google ads - conversion rate': t('GRAAS_GOOGLE_ADS_CONVERSION_RATE_GRAAS'),
    'tracker - # orders': t('GRAAS_TRACKER_ORDERS_GRAAS'),
    'fb ads - impressions': t('GRAAS_FB_ADS_IMPRESSIONS_GRAAS'),
    'fb ads - revenue': t('GRAAS_FB_ADS_REVENUE_GRAAS'),
    'fb ads - cost per conversion': t('GRAAS_FB_ADS_COST_PER_CONVERSION_GRAAS'),
    'fb - ad campaign revenue': t('GRAAS_FB_AD_CAMPAIGN_REVENUE_GRAAS'),
    'fb ads - conversions': t('GRAAS_FB_ADS_CONVERSIONS_GRAAS'),
    'delhivery - count of orders': t('GRAAS_DELHIVERY_COUNT_OF_ORDERS_GRAAS'),
    'tracker - revenue': t('GRAAS_TRACKER_REVENUE_GRAAS')
  },
  tags: {
    label: 'Tags',
    value: 'tags'
  },
  dimensions: {
    label: 'GRAAS_DIMENSIONS_GRAAS',
    value: 'dimensions',
    channel: t('GRAAS_CHANNEL_GRAAS'),
    keywords: t('GRAAS_KEYWORDS_GRAAS'),
    overall: t('GRAAS_OVERALL_GRAAS'),
    'products bought together': t('GRAAS_PRODUCTS_BOUGHT_TOGETHER_GRAAS'),
    'user type': t('GRAAS_USER_TYPE_GRAAS'),
    device: t('GRAAS_DEVICE_GRAAS'),
    'top selling sku': t('GRAAS_TOP_SELLING_SKU_GRAAS')
  },
  due_status: {
    label: 'GRAAS_DUE_STATUS_GRAAS',
    value: 'due_status',
    due_soon: t('GRAAS_DUE_SOON_GRAAS'),
    result_soon: t('GRAAS_RESULT_SOON_GRAAS'),
    initialState: [
      {
        _id: 'Due Soon',
        value: 'due_soon',
        doc_count: 0
      },
      {
        _id: 'Result Soon',
        value: 'result_soon',
        doc_count: 0
      }
    ]
  }
};

// -- code to display actual name of selected filter tag
export const actualFilterTagTitles = [
  {
    value: 'to_do',
    title: t('GRAAS_NEW_GRAAS'),
    icon: 'today',
    isIconColored: true,
    iconColor: 'success'
  },
  {
    value: 'new',
    title: t('GRAAS_NEW_GRAAS'),
    icon: 'today',
    isIconColored: true,
    iconColor: 'success'
  },
  {
    value: 'done',
    title: t('GRAAS_COMPLETED_GRAAS'),
    icon: 'check_circle',
    isIconColored: true,
    iconColor: 'success'
  },
  {
    value: 'completed',
    title: t('GRAAS_COMPLETED_GRAAS'),
    icon: 'check_circle',
    isIconColored: true,
    iconColor: 'success'
  },
  {
    value: 'Completed',
    title: t('GRAAS_COMPLETED_GRAAS'),
    icon: 'check_circle',
    isIconColored: true,
    iconColor: 'success'
  },
  {
    value: 'in_progress',
    title: t('GRAAS_IN_PROGRESS_GRAAS'),
    icon: 'hourglass_top',
    isIconColored: false
  },
  {
    value: 'InProgress',
    title: t('GRAAS_IN_PROGRESS_GRAAS'),
    icon: 'hourglass_top',
    isIconColored: false
  },
  {
    value: 'minor',
    title: t('GRAAS_LOW_GRAAS'),
    icon: 'check_circle',
    isIconColored: true,
    iconColor: 'success'
  },
  {
    value: 'major',
    title: t('GRAAS_MODERATE_GRAAS'),
    icon: 'check_circle',
    isIconColored: true,
    iconColor: 'success'
  },
  {
    value: 'execution_failed',
    title: t('GRAAS_FAILED_GRAAS'),
    icon: 'timer_off',
    isIconColored: true,
    iconColor: 'alert'
  },
  {
    value: 'failed',
    title: t('GRAAS_FAILED_GRAAS'),
    icon: 'error_outline',
    isIconColored: true,
    iconColor: 'alert'
  },
  {
    value: 'ignore',
    title: t('GRAAS_IGNORE_GRAAS'),
    icon: 'highlight_off',
    isIconColored: true,
    iconColor: 'warning'
  },
  {
    value: 'critical',
    title: t('GRAAS_HIGH_IMPACT_GRAAS'),
    icon: 'check_circle'
  },
  {
    value: 'lowImpact',
    title: t('GRAAS_LOW_GRAAS'),
    icon: 'error_outline'
  },
  {
    value: 'expired',
    title: t('GRAAS_EXPIRED_GRAAS'),
    icon: 'timer_off',
    isIconColored: true
  }
];

// --- Initial states for top date range selection
export const dateRangeMapping = {
  one_week: {
    key: 'one_week',
    title: 'One Week',
    short_code: '1W',
    value: [moment().subtract(1, 'week'), moment()]
  },
  one_month: {
    key: 'one_month',
    title: 'One Month',
    short_code: '1M',
    value: [moment().subtract(1, 'months'), moment()]
  },
  three_month: {
    key: 'three_month',
    title: 'Three Month',
    short_code: '3M',
    value: [moment().subtract(3, 'months'), moment()]
  }
};

export const dateRangeMappingWithFormeted = {
  one_week: {
    key: 'one_week',
    title: 'One Week',
    short_code: '1W',
    value: [moment().subtract(1, 'week').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
  },
  one_month: {
    key: 'one_month',
    title: 'One Month',
    short_code: '1M',
    value: [moment().subtract(1, 'months').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
  },
  three_month: {
    key: 'three_month',
    title: 'Three Month',
    short_code: '3M',
    value: [moment().subtract(3, 'months').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
  }
};

export const endUserStatusSupportedStatus = {
  in_progress: ['execution_failed', 'done'],
  to_do: ['done', 'in_progress']
};

export const detailViewGoBackData = {
  default: '/predict',
  insights: '/analyze/insights',
  dashboard: '/analyze',
  CIDashboard: '/analyze/competitive-dashboard',
  marketingDashboard: '/analyze/marketing-dashboard',
  D2CDashboard: '/analyze/marketplace-d2c-dashboard-beta',
  insightDetails: '/analyze/insights/insight-details',
  dashboardToRecommendation: '/predict',
  insightsToInsights: '/analyze/insights/insight-details'
};

export const breadScurmbData = {
  recoDefault: 'GRAAS_RECOMMENDATION_GRAAS',
  insightDefault: 'GRAAS_INSIGHTS_GRAAS',
  dashboard: 'GRAAS_DASHBOARD_GRAAS',
  CIDashboard: 'GRAAS_COMPETETIVE_DASHBOARD_GRAAS',
  marketingDashboard: 'GRAAS_MARKETING_DASHBOARD',
  D2CDashboard: 'GRAAS_D2C_DASHBOARD_GRAAS',
  insightDetails: 'GRAAS_INSIGHT_DETAILS_GRAAS',
  insightList: 'GRAAS_INSIGHT_LIST_GRAAS',
  dashboardToRecommendation: 'GRAAS_DASHBOARD_GRAAS',
  insightsToInsights: 'GRAAS_INSIGHTS_GRAAS',
  workspace: 'GRAAS_WORKSPACE_GRAAS'
};
